// extracted by mini-css-extract-plugin
export var active = "_el-7";
export var container = "_el-0";
export var evenWidth = "_el-4";
export var large = "_el-5";
export var outlet = "_el-8";
export var slide = "_el-2";
export var small = "_el-6";
export var tab = "_el-3";
export var tabs = "_el-1";